module.exports = __webpack_public_path__ + "assets/yin.80319f57.svg";